import Inspector from './inspector';
const { RichText, InnerBlocks } = wp.blockEditor;

export default ({ attributes, setAttributes }) => {
  const { margin } = attributes;

  const handleOnChangeTitle = (title) => {
    setAttributes({ title });
  };
  const handleOnChangeSubtitle = (subtitle) => {
    setAttributes({ subtitle });
  };

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <section className={`AboutUs-card ${margin}`}>
        <div className="about-us-cards-content Container">
          <div className="about-us-cards-text">
            <RichText
              tagName="h2"
              className="Typography title-5 left color-blue-dark margin-small"
              placeholder={'Título'}
              value={attributes.title}
              onChange={handleOnChangeTitle}
            />
            <RichText
              tagName="p"
              className="Typography text left color-black margin-none"
              placeholder={'Subtítulo'}
              value={attributes.subtitle}
              onChange={handleOnChangeSubtitle}
            />
          </div>
          <div className="about-us-cards-swiper__cards about-us-cards-swiper margin-medium">
            <div className="swiper-wrapper">
              <InnerBlocks
                template={[['about-us-cards-card/block']]}
                allowedBlocks={['about-us-cards-card/block']}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
